var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 13C28.523 13 33 17.477 33 23C33 28.523 28.523 33 23 33C17.477 33 13 28.523 13 23C13 17.477 17.477 13 23 13ZM23 17C22.7348 17 22.4804 17.1054 22.2929 17.2929C22.1054 17.4804 22 17.7348 22 18V23C22.0001 23.2652 22.1055 23.5195 22.293 23.707L25.293 26.707C25.4816 26.8892 25.7342 26.99 25.9964 26.9877C26.2586 26.9854 26.5094 26.8802 26.6948 26.6948C26.8802 26.5094 26.9854 26.2586 26.9877 25.9964C26.99 25.7342 26.8892 25.4816 26.707 25.293L24 22.586V18C24 17.7348 23.8946 17.4804 23.7071 17.2929C23.5196 17.1054 23.2652 17 23 17Z",
    fill: "#6D5FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiming);
export default __webpack_public_path__ + "static/media/timing.b750da8dd14654e570445ba484e15a9c.svg";
export { ForwardRef as ReactComponent };